<template>
  <menu-list>
    <template slot="1"><internal-link name="team">{{ $t('team') }}</internal-link></template>
    <template slot="2"><internal-link name="contact">{{ $t('contact') }}</internal-link></template>
    <template slot="3">
      <internal-link><switcher-container/></internal-link>
    </template>
  </menu-list>
</template>

<script>
import MenuList from '@/containers/Navigation/MenuList'
import SwitcherContainer from '@/containers/Navigation/SwitcherContainer'
import InternalLink from '@/components/InternalLink'

export default {
  components: {
    MenuList,
    InternalLink,
    SwitcherContainer
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Navigation/RightMenuContainer.vue